import ChargeCredit from "../components/pricing-plan/ChargeCredit";
import { Modal } from "antd";
import React from "react";

function ChargeCreditModal({ open, onClose }) {
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Modal open={open} onCancel={onClose} footer={null} centered>
        <ChargeCredit />
      </Modal>
    </div>
  );
}

export default ChargeCreditModal;
